import { getQueryParam } from "./query";

/**
 * 首次进入页 URL：优先地址栏 first_url，其次 sessionStorage
 */
export const getFirstUrl = () => {
  if (typeof window === "undefined") {
    return "";
  }
  return (
    decodeURIComponent(getQueryParam("first_url") || "") ||
    window.sessionStorage.getItem("first_url") ||
    ""
  );
};
